import { UserRole, getUserRoleLabel, UserRoleColors } from '@/lib/userRoles';

interface UserRoleBadgeProps {
  role: UserRole | number | null | undefined;
  className?: string;
}

const UserRoleBadge = ({ role, className = '' }: UserRoleBadgeProps) => {
  if (role === null || role === undefined) {
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 ${className}`}>
        Sin rol
      </span>
    );
  }

  const label = getUserRoleLabel(role);
  const colorClass = UserRoleColors[role as UserRole] || 'bg-gray-100 text-gray-800';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}>
      {label}
    </span>
  );
};

export default UserRoleBadge; 